import React from 'react';
import clsx from 'clsx';

import './CommonStepper.scss';

function StepLabel({ children, ownerState }) {
  return (
    <div
      className={clsx(
        'common-stepper-label',
        (ownerState.active || ownerState.completed) && 'common-stepper-label--active',
      )}>
      <span>{children}</span>
    </div>
  );
}

export default StepLabel;
